import dayjs from 'dayjs';

export function formatMoney(value) {
    const n = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(n)) return '—';
    return n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function parseMoneyNumber(value) {
    if (value === null || typeof value === 'undefined') return 0;
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
    const raw = String(value).trim();
    if (!raw) return 0;
    const digits = raw.replace(/[^\d]/g, '');
    const n = digits ? Number(digits) : 0;
    return Number.isFinite(n) ? n : 0;
}

export function toDayjs(value) {
    if (!value) return null;
    if (dayjs.isDayjs(value)) return value;
    if (typeof value?.toDate === 'function') {
        const out = dayjs(value.toDate());
        return out.isValid() ? out : null;
    }
    // Firestore Timestamp-like plain object
    if (typeof value === 'object' && typeof value?.seconds === 'number') {
        const ms = value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1e6);
        const out = dayjs(new Date(ms));
        return out.isValid() ? out : null;
    }
    const out = dayjs(value instanceof Date ? value : value);
    return out.isValid() ? out : null;
}

export function getEntryDisplayDayjs(entry) {
    if (!entry || typeof entry !== 'object') return null;
    return (
        toDayjs(entry.date) ||
        toDayjs(entry.createdAt) ||
        toDayjs(entry.createdAtLocal) ||
        toDayjs(entry.updatedAt) ||
        toDayjs(entry.updatedAtLocal) ||
        null
    );
}

